import { gql } from '@apollo/client';
import client from 'graphql/client';
import { omit } from 'lodash';
import { CompanyBenefit } from 'types/profile.types';
import { CompanyProfileBenefitsMutation } from './types';

const apiSyncCompanyBenefits = (profileId: number | null, payload: CompanyBenefit[]) => {
  let variables: CompanyProfileBenefitsMutation = {
    profileId,
    companyBenefits: payload.map((benefit: CompanyBenefit) => {
      return omit(benefit, ['id', 'benefitType', 'uid', '__typename']);
    }),
  };

  const mutation = gql`
    mutation companyProfileBenefitsMutation(
      $profileId: Int!
      $companyBenefits: [CompanyProfileCompanyBenefitInput]
    ) {
      companyProfileBenefitsMutation(id: $profileId, companyBenefits: $companyBenefits) {
        benefitType {
          id
          titleSr
          titleEn
          inputExampleSr
          inputExampleEn
          iconClass
        }
        description
        hidden
        id
        order
        customTitle
      }
    }
  `;

  return client.mutate({
    mutation,
    variables,
  });
};

export default apiSyncCompanyBenefits;
